export const DASHBOARD_EXCLUDED_STATUS = "CPAP Follow Up";

export const shouldShowDashboardFollowup = (item) =>
  item.status !== DASHBOARD_EXCLUDED_STATUS;

export const getDashboardStatusOptions = (statusOptions) =>
  statusOptions.filter((item) => item.value !== DASHBOARD_EXCLUDED_STATUS);
